import { render, staticRenderFns } from "./ClinicInfoManage.vue?vue&type=template&id=2676dd0c&scoped=true"
import script from "./ClinicInfoManage.vue?vue&type=script&lang=js"
export * from "./ClinicInfoManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2676dd0c",
  null
  
)

export default component.exports